import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import React, { useContext, useEffect } from "react";
import {
  ContentfulContext,
  ContentfulContextValue,
} from "../../ContentfulProvider";
import { FaqEntry } from "@src/services/contentful/faq/faqParser";
import {
  IFaq,
  IFaqEntry,
  IFaqEntryFields,
  IFaqFields,
} from "@src/types/generated/contentful";
import { FAQPageJsonLd } from "next-seo";
import { renderDocumentToHtmlString } from "@src/components/atoms/TextBlock";

type FaqSchemaProps = {
  entries: IFaq[];
};

const buildFaqSchema = (entries: IFaq[]) => {
  const entities = entries?.map((entry: any) => {
    const e = entry?.fields as IFaqEntryFields;
    const question = e?.question;
    let answer = renderDocumentToHtmlString(e.answer, {});

    const json = {
      "@type": "Question",
      name: question,
      acceptedAnswer: {
        "@type": "Answer",
        text: answer,
      },
    };

    return json;
  });

  const faqObject = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: entities,
  };

  return faqObject;
};
const FaqSchema = (props: FaqSchemaProps) => {
  const { entries } = props;

  const schemas = buildFaqSchema(entries);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `${JSON.stringify(schemas)}`,
      }}
    />
  );
};

export default FaqSchema;

/**
 *  *****************  ADD BACK THESE FAQs   *****************
 * {
  "data": {
    "faqCollection": {
      "items": [
        {
          "header": "FAQs for Cancer Screening Tests",
          "linkedFrom": {
            "postCollection": {
              "items": [
                {
                  "slug": "does-medicare-cover-cancer-screening-tests-for-females"
                }
              ]
            }
          }
        },
        {
          "header": "Medicare Chiropractor Coverage FAQs",
          "linkedFrom": {
            "postCollection": {
              "items": [
                {
                  "slug": "can-medicare-pay-for-a-chiropractor"
                }
              ]
            }
          }
        },
        {
          "header": "Medicare Supplement Plan G FAQs",
          "linkedFrom": {
            "postCollection": {
              "items": [
                {
                  "slug": "all-about-medicare-supplement-plan-g-benefits"
                }
              ]
            }
          }
        },
        {
          "header": "Other COVID-19 Booster FAQs",
          "linkedFrom": {
            "postCollection": {
              "items": [
                {
                  "slug": "understanding-covid-19-booster-shot-eligibility"
                }
              ]
            }
          }
        },
        {
          "header": "Medicare Heart Transplant FAQs",
          "linkedFrom": {
            "postCollection": {
              "items": [
                {
                  "slug": "does-medicare-cover-heart-transplants"
                }
              ]
            }
          }
        },
        {
          "header": "Other Important D-SNP Frequently Asked Questions",
          "linkedFrom": {
            "postCollection": {
              "items": [
                {
                  "slug": "growing-number-of-people-join-medicare-advantage-dual-eligible-special-needs"
                }
              ]
            }
          }
        },
        {
          "header": "Facts About the Alzheimer’s Cognitive Assessment",
          "linkedFrom": {
            "postCollection": {
              "items": [
                {
                  "slug": "does-medicare-cover-alzheimers"
                }
              ]
            }
          }
        },
        {
          "header": "Your healthy food options",
          "linkedFrom": {
            "postCollection": {
              "items": [
                {
                  "slug": "how-family-gatherings-and-good-food-can-improve-your-health"
                }
              ]
            }
          }
        },
        {
          "header": "Common Questions about Shingles Vaccine",
          "linkedFrom": {
            "postCollection": {
              "items": [
                {
                  "slug": "does-medicare-cover-the-shingles-vaccine"
                }
              ]
            }
          }
        },
        {
          "header": "Common Questions about Skilled Nursing Facilities (SNF)",
          "linkedFrom": {
            "postCollection": {
              "items": [
                {
                  "slug": "does-medicare-cover-skilled-nursing-facility"
                }
              ]
            }
          }
        },
        {
          "header": "Common Questions about Osteoporosis",
          "linkedFrom": {
            "postCollection": {
              "items": [
                {
                  "slug": "does-medicare-cover-prolia"
                }
              ]
            }
          }
        },
        {
          "header": "Common Questions about Chiropractic Services",
          "linkedFrom": {
            "postCollection": {
              "items": [
                {
                  "slug": "does-medicare-supplement-plan-g-cover-chiropractors"
                }
              ]
            }
          }
        },
        {
          "header": "COMMON QUESTIONS ABOUT MEDICARE COSTS",
          "linkedFrom": {
            "postCollection": {
              "items": []
            }
          }
        }
      ]
    }
  }
}

 */
